import React, { Component } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import OptionsEnroll from './OptionsEnroll';

class Source extends Component {
  shouldComponentUpdate (nextProps) {
    const { environment } = this.props.match.params;
    if (environment !== nextProps.match.params.environment) {
      return {
        ...nextProps,
      };
    }
    return null;
  }

  render () {
    const { setOption } = this.props;
    const alunbrigForms = [
      {
        formId: 'PATIENT',
        formTitle: 'Patient or Care partner',
        linkTo: '/alunbrig/patient',
        tracking: 'track-8 gtm-track-05 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'I need a card',
          linkTo: '/alunbrig/patient/enroll/eligibility',
          tracking: 'track-12 gtm-track-17 track-env-home',
        },
        {
          name: 'Replace',
          description: 'I lost my card',
          linkTo: '/alunbrig/patient/replace/patient-information',
          tracking: 'track-14 gtm-track-18 track-env-home',
        }],
      },
      {
        formId: 'STAFF',
        formTitle: 'Healthcare Professional or staff',
        linkTo: '/alunbrig/hps',
        tracking: 'track-9 gtm-track-06 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/alunbrig/hps/enroll/eligibility',
          tracking: 'track-17 gtm-track-29 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/alunbrig/hps/replace/patient-information',
          tracking: 'track-19 gtm-track-30 track-env-home',
        }],
      },
      {
        formId: 'PHARMACIST',
        formTitle: 'Pharmacist',
        linkTo: '/alunbrig/pharmacist',
        tracking: 'track-10 gtm-track-07 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/alunbrig/pharmacist/enroll/eligibility',
          tracking: 'track-22 gtm-track-41 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/alunbrig/pharmacist/replace/patient-information',
          tracking: 'track-24 gtm-track-42 track-env-home',
        }],
      },
    ];
    const fruzaqlaForms = [
      {
        formId: 'PATIENT',
        formTitle: 'Patient or Care partner',
        linkTo: '/fruzaqla/patient',
        tracking: 'track-70 gtm-track-116 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'I need a card',
          linkTo: '/fruzaqla/patient/enroll/eligibility',
          tracking: 'track-71 gtm-track-117 track-env-home',
        },
        {
          name: 'Replace',
          description: 'I lost my card',
          linkTo: '/fruzaqla/patient/replace/patient-information',
          tracking: 'track-72 gtm-track-118 track-env-home',
        }],
      },
      {
        formId: 'STAFF',
        formTitle: 'Healthcare Professional or staff',
        linkTo: '/fruzaqla/hps',
        tracking: 'track-74 gtm-track-120 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/fruzaqla/hps/enroll/eligibility',
          tracking: 'track-75 gtm-track-121 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/fruzaqla/hps/replace/patient-information',
          tracking: 'track-76 gtm-track-122 track-env-home',
        }],
      },
      {
        formId: 'PHARMACIST',
        formTitle: 'Pharmacist',
        linkTo: '/fruzaqla/pharmacist',
        tracking: 'track-78 gtm-track-124 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/fruzaqla/pharmacist/enroll/eligibility',
          tracking: 'track-79 gtm-track-125 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/fruzaqla/pharmacist/replace/patient-information',
          tracking: 'track-80 gtm-track-126 track-env-home',
        }],
      },
    ];
    const iclusigForms = [
      {
        formId: 'PATIENT',
        formTitle: 'Patient or Care partner',
        linkTo: '/iclusig/patient',
        tracking: 'track-27 gtm-track-08 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'I need a card',
          linkTo: '/iclusig/patient/enroll/eligibility',
          tracking: 'track-31 gtm-track-20 track-env-home',
        },
        {
          name: 'Replace',
          description: 'I lost my card',
          linkTo: '/iclusig/patient/replace/patient-information',
          tracking: 'track-33 gtm-track-21 track-env-home',
        }],
      },
      {
        formId: 'STAFF',
        formTitle: 'Healthcare Professional or staff',
        linkTo: '/iclusig/hps',
        tracking: 'track-28 gtm-track-09 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/iclusig/hps/enroll/eligibility',
          tracking: 'track-36 gtm-track-32 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/iclusig/hps/replace/patient-information',
          tracking: 'track-38 gtm-track-33 track-env-home',
        }],
      },
      {
        formId: 'PHARMACIST',
        formTitle: 'Pharmacist',
        linkTo: '/iclusig/pharmacist',
        tracking: 'track-29 gtm-track-10 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/iclusig/pharmacist/enroll/eligibility',
          tracking: 'track-41 gtm-track-44 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/iclusig/pharmacist/replace/patient-information',
          tracking: 'track-43 gtm-track-45 track-env-home',
        }],
      },
    ];
    const ninlaroForms = [
      {
        formId: 'PATIENT',
        formTitle: 'Patient or Care partner',
        linkTo: '/ninlaro/patient',
        tracking: 'track-46 gtm-track-11 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'I need a card',
          linkTo: '/ninlaro/patient/enroll/eligibility',
          tracking: 'track-49 gtm-track-23 track-env-home',
        },
        {
          name: 'Replace',
          description: 'I lost my card',
          linkTo: '/ninlaro/patient/replace/patient-information',
          tracking: 'track-51 gtm-track-24 track-env-home',
        }],
      },
      {
        formId: 'STAFF',
        formTitle: 'Healthcare Professional or staff',
        linkTo: '/ninlaro/hps',
        tracking: 'track-47 gtm-track-12 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/ninlaro/hps/enroll/eligibility',
          tracking: 'track-54 gtm-track-35 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/ninlaro/hps/replace/patient-information',
          tracking: 'track-56 gtm-track-36 track-env-home',
        }],
      },
      {
        formId: 'PHARMACIST',
        formTitle: 'Pharmacist',
        linkTo: '/ninlaro/pharmacist',
        tracking: 'track-48 gtm-track-13 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/ninlaro/pharmacist/enroll/eligibility',
          tracking: 'track-59 gtm-track-47 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/ninlaro/pharmacist/replace/patient-information',
          tracking: 'track-61 gtm-track-48 track-env-home',
        }],
      },
    ];
    const mimryloForms = [
      {
        formId: 'PATIENT',
        formTitle: 'Patient or Care partner',
        linkTo: '/mimrylo/patient',
        tracking: 'track-46 gtm-track-11 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'I need a card',
          linkTo: '/mimrylo/patient/enroll/eligibility',
          tracking: 'track-49 gtm-track-23 track-env-home',
        },
        {
          name: 'Replace',
          description: 'I lost my card',
          linkTo: '/mimrylo/patient/replace/patient-information',
          tracking: 'track-51 gtm-track-24 track-env-home',
        }],
      },
      {
        formId: 'STAFF',
        formTitle: 'Healthcare Professional or staff',
        linkTo: '/mimrylo/hps',
        tracking: 'track-47 gtm-track-12 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/mimrylo/hps/enroll/eligibility',
          tracking: 'track-54 gtm-track-35 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/mimrylo/hps/replace/patient-information',
          tracking: 'track-56 gtm-track-36 track-env-home',
        }],
      },
      {
        formId: 'PHARMACIST',
        formTitle: 'Pharmacist',
        linkTo: '/mimrylo/pharmacist',
        tracking: 'track-48 gtm-track-13 track-env-home',
        forms: [{
          name: 'Enroll',
          description: 'My patient needs a card',
          linkTo: '/mimrylo/pharmacist/enroll/eligibility',
          tracking: 'track-59 gtm-track-47 track-env-home',
        },
        {
          name: 'Replace',
          description: 'My patient lost their card',
          linkTo: '/mimrylo/pharmacist/replace/patient-information',
          tracking: 'track-61 gtm-track-48 track-env-home',
        }],
      },
    ];
    return (
      <div className="enroll full-width">
        <div className="wrapper">
          <Switch>
            <Route
              path="/alunbrig"
              component={ () => (
                <OptionsEnroll
                  setOption={ setOption }
                  formList={ alunbrigForms }
                />
              ) }
            />
            <Route
              path="/fruzaqla"
              component={ () => (
                <OptionsEnroll
                  setOption={ setOption }
                  formList={ fruzaqlaForms }
                />
              ) }
            />
            <Route
              path="/iclusig"
              component={ () => (
                <OptionsEnroll
                  setOption={ setOption }
                  formList={ iclusigForms }
                />
              ) }
            />
            <Route
              path="/ninlaro"
              component={ () => (
                <OptionsEnroll
                  setOption={ setOption }
                  formList={ ninlaroForms }
                />
              ) }
            />
            <Route
              path="/mimrylo"
              component={ () => (
                <OptionsEnroll
                  setOption={ setOption }
                  formList={ mimryloForms }
                />
              ) }
            />
          </Switch>
        </div>
      </div>
    );
  }
}

Source.propTypes = {
  setOption: PropTypes.func.isRequired,
  optionSelected: PropTypes.string,
};

export default withRouter(Source);
